import type { VoidFunctionComponent } from 'react';
import { FluidLeftLayout } from '../../../layouts';
import ResolvedReason from '../ResolvedReason';
import Dependency from '../Vulnerability/Dependency';
import Description from '../Vulnerability/Description';
import Remediation from '../Vulnerability/Remediation';
import Details from '../Vulnerability/Details';
import NVDBaseMetrics from '../Vulnerability/NVDBaseMetrics';
import References from '../Vulnerability/References';

/**
 * A component that renders the detailed content of a vulnerability issue in a full-page layout.
 */
const VulnerabilityIssueDetailContent: VoidFunctionComponent = () => (
  <FluidLeftLayout>
    <FluidLeftLayout.Left>
      <ResolvedReason />
      <Remediation />
      <Details />
      <Dependency />
    </FluidLeftLayout.Left>
    <FluidLeftLayout.Right>
      <Description />
      <NVDBaseMetrics />
      <References />
    </FluidLeftLayout.Right>
  </FluidLeftLayout>
);

export default VulnerabilityIssueDetailContent;
